import React, { Fragment, memo } from "react"
import { InfiniteScroll, PullToRefresh, DotLoading } from "antd-mobile"
import "./index.scss"
import Empty from '../empty';
import noData from '@/assets/img/noCollection.png';

/*
    // 基本用例
    <ListView 
        dataSource={list}
        renderHeader={renderHeader}
        renderFooter={renderFooter}
        renderItem={renderItem}
        hasMore={hasMore}
        onRefresh={()=>{
            currentPage.current = 1
            loadData()
        }}
        onEndReached={loadMore}
    />

    //或
    <ListView 
        hasMore={hasMore}
        onRefresh={()=>{
            currentPage.current = 1
            loadData()
        }}
        onEndReached={loadMore}
    >
        {
            list.map((item,index)=> {
                return renderItem(item,index)
            })
        }
    </ListView>

*/

const InfiniteScrollContent = ({ hasMore }) => {
  return (
    <>
      {hasMore ? (
        <>
          <span>Loading</span>
          <DotLoading />
        </>
      ) : null}
    </>
  )
}

const ListView = (props) => {
    const {
            dataSource=[], 
            renderHeader,
            renderItem, 
            renderFooter,
            onRefresh, 
            onEndReached, 
            onEndReachedThreshold,
            infiniteContent,
            hasMore=false, 
            emtyDesc='暂无数据',
            style,
            isLoad,
            customStyle
        } = props

    return (
        <div className="ant-list-view">
            <PullToRefresh 
              onRefresh={onRefresh} 
              disabled={onRefresh ? false : true}
              headHeight={70}
              threshold={100}
              pullingText={
                <img 
                  src={require('@/assets/img/new-loading.gif')}
                  style={{height: 50}} alt=''
                />
              }
              refreshingText={
                <img
                  src={require('@/assets/img/new-loading.gif')}
                  style={{height: 50}} alt=''
                />
              }
              canReleaseText={
                <img
                  src={require('@/assets/img/new-loading.gif')}
                  style={{height: 50}} alt=''
                  />
                }
              renderText={null}
            >
                <div className="list-view-content">
                    { renderHeader && renderHeader() }
                    {
                        props.children ? props.children:
                        <div className="list-view-body">
                        {
                            dataSource.length > 0 ? 
                            dataSource.map((item, index) => <Fragment key={index}>{renderItem(item,index,dataSource)}</Fragment>) : 
                            isLoad ? <Empty 
                                image={noData} 
                                description={emtyDesc}
                                style={style}
                                customStyle={customStyle}
                            />: null
                        }
                        </div>
                        }
                    { renderFooter && renderFooter() }
                </div>
                {
                    onEndReached &&
                    <InfiniteScroll loadMore={onEndReached} hasMore={hasMore} threshold={onEndReachedThreshold}>
                        {
                            infiniteContent ? <>{hasMore ? infiniteContent() : null}</>:
                            <InfiniteScrollContent hasMore={hasMore} />
                        }
                    </InfiniteScroll>
                }
            </PullToRefresh>
        </div>
    )
}

export default memo(ListView);
